import moment from "moment";
import GenericSelectableTable from "../selectableTable";
import { toast } from "react-toastify";

function PromoUsageTable({ data }: any) {
  const columns = [
    {
      header: "ID", key: "id", render: (item: any)=>(
        <div className="text-start py-3">
          #ID{item.id}
        </div>
      )
    },
    {
      header: "Customer", key: "customer"
    },
 
    {
      header: "Promocode", key: "promocode"
    },
    {
      header: "Order", key: "order"
    },
    {
      header: "Date and Time", key: "created_at", render: (item: any)=>(
        moment(item.created_at).format("MMMM D, YYYY h:mm A")
      )
    },
  ]

  const bullkActionButtons = [
    {
      label: 'Delete Selected',
      onClick: (selectedItems:any) => {
        toast.success(`Delete items: ${Array.from(selectedItems)}`);
        // Implement delete logic here
      },
    },
    {
      label: 'Export Selected',
      onClick: (selectedItems:any) => {
        toast.success(`Export items: ${Array.from(selectedItems)}`);
        // Implement export logic here
      },
    },
  ];
  return (
    <div>
      <GenericSelectableTable columns={columns} data={data} bullkActionButtons={bullkActionButtons}/>
    </div>
  );
}

export default PromoUsageTable;
